import { ColumnDef, createColumnHelper } from "@tanstack/react-table"
import { DateCell, DocumentActionsCell, TextCell } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { ExportRequestResponseDto } from "~/gen/api"
import { fetchDocumentUrl } from "~/hooks/useDocumentsQuery"
import { ExportStatusBadge } from "~/pages/Brand/DataTransfer/Export/ExportStatusBadge"

const columnHelper = createColumnHelper<ExportRequestResponseDto>()
export const useColumns = () => {
  const { t } = useTranslation(["dataTransfer", "common"])

  return useMemo<ColumnDef<ExportRequestResponseDto, any>[]>(
    () => [
      columnHelper.accessor("exportConfiguration.name", {
        header: t("dataTransfer:columns.name"),
        cell: (info) => <TextCell value={info.getValue()} />,
      }),
      columnHelper.accessor("createdAt", {
        header: t("dataTransfer:columns.launchedAt"),
        cell: (info) => <DateCell date={info.getValue()} format="lll" />,
      }),
      columnHelper.accessor("exportReport.total", {
        header: t("dataTransfer:columns.rowsCount"),
        cell: (info) => <TextCell value={info.getValue()} />,
      }),
      columnHelper.accessor("status", {
        header: t("dataTransfer:columns.status"),
        cell: (info) => <ExportStatusBadge status={info.getValue()} />,
      }),
      columnHelper.display({
        id: "action-cell-document",
        header: undefined,
        cell: (info) => {
          const { document } = info.row.original

          return document ? (
            <DocumentActionsCell
              documentId={document.id}
              documentName={document.originalName}
              filename={document.originalName ?? undefined}
              fetchDownloadUrl={() => fetchDocumentUrl(document.id, true)}
              fetchViewUrl={() => fetchDocumentUrl(document.id)}
              missingDocumentText={t("common:documentUpload.missingDocument")}
            />
          ) : null
        },
      }),
    ],
    [t]
  )
}
